import { ObservableFromFetch } from "../ObservableFromFetch"

export default function ResetLoginAttempts(userName: string) {
  const requestBody: string = new URLSearchParams({ UserName: userName.toString() }).toString()
  return ObservableFromFetch<string>("WorkforceSuperUser/ResetLoginAttempts?" + requestBody, "post")
}
